import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {NestApiProvider} from '../../nest-api';

@Injectable()
export class BankMgtProvider {

  private _service: string = 'payroll';
  private _model: string = 'bankmgt';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public getBalance(): Observable<any> {
    const _method: string = 'GET';

    const _func: string = 'balance';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    // if (typeof filter !== 'undefined' && filter !== null) _urlParams.filter = filter;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _func, _params, _body);
  }
  public getListDisbursement(filter: any): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'disbursement';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof filter.param !== 'undefined' && filter.param !== null) _urlParams.param = JSON.stringify(filter.param);
    if (typeof filter.limit !== 'undefined' && filter.limit !== null) _urlParams.limit = filter.limit;
    if (typeof filter.skip !== 'undefined' && filter.skip !== null) _urlParams.skip = filter.skip;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }
  public downloadReport(body: any): Observable<any> {
    const _method: string = 'POST';
    const _func: string = 'disbursement/downloadReport';
    const _params: any = body;
    const _urlParams: any = {};
    const _body: any = {};


    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.requestBlob(_method, _url, _params, _body);
  }
  
  public getDisbursementDetail(disbursementCode: any,periodCode : any, payDate): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'getDisbursementDetail';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof disbursementCode !== 'undefined' && disbursementCode !== null) _urlParams.disbursementCode = disbursementCode;
    if (typeof periodCode !== 'undefined' && periodCode !== null) _urlParams.periodCode = periodCode;
    if (typeof payDate !== 'undefined' && payDate !== null) _urlParams.payDate = payDate;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }
  public getAllTransfer(filter: any): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'getAllTransfer';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof filter.payDate !== 'undefined' && filter.payDate !== null) _urlParams.payDate = filter.payDate;
    if (typeof filter.periodCode !== 'undefined' && filter.periodCode !== null) _urlParams.periodCode = filter.periodCode;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }
  public getListBank(): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'getBankSupport';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};


    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }
  public getListStatus(): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'disbursement/status?type=detail';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};


    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }
  public getListAccountType(): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'account/type';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};


    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }
  public getCompany(): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'company';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};


    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/payroll/bankmgt/bankmgt.ts